// ========== TermsPage.jsx ==========
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StaticPages.css';

const TermsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="static-page">
      <header className="static-header">
        <nav className="static-nav">
          <div className="logo" onClick={() => navigate('/')}> Mellodai</div>
          <a onClick={() => navigate('/')}> Back to Home</a>
        </nav>
      </header>

      <div className="content-container">
        <div className="hero" style={{padding: '80px 2rem 40px', marginTop: 0}}>
          <h1> Terms and Conditions of Service</h1>
        </div>

        <div className="content-section">
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing or using the Service, you agree to be bound by these Terms. If you disagree with any part, you may not access the Service.</p>
        </div>

        <div className="content-section">
          <h2>2. Nature of the Service and Disclaimer</h2>
          <h3>A. Probabilistic Forecasting</h3>
          <p>The Service provides statistical probability forecasts based on historical data using advanced Machine Learning (Neural Networks).</p>

          <h3>B. Not Guaranteed</h3>
          <div style={{background: 'rgba(239, 68, 68, 0.1)', padding: '1.5rem', borderRadius: '10px', borderLeft: '4px solid #ef4444', margin: '1.5rem 0'}}>
            <p style={{fontWeight: 'bold', color: '#fca5a5', margin: 0}}> IMPORTANT: Predictions are NOT guarantees, prophecies, or absolute facts. They are statistical insights only. All life decisions remain solely your responsibility.</p>
          </div>

          <h3>C. No Professional Advice</h3>
          <p>The Service does not provide medical, legal, financial, or psychological advice. Consult appropriate professionals before major life decisions.</p>
        </div>

        <div className="content-section">
          <h2>3. User Data Input and Contribution</h2>
          <h3>A. Required Input</h3>
          <p>You must provide comprehensive, factual details of past major life events. Accuracy affects prediction quality.</p>

          <h3>B. Paid User Contributions</h3>
          <p>Paid users can voluntarily contribute life events to the dataset. Data undergoes verification and is integrated anonymously for model training.</p>
        </div>

        <div className="content-section">
          <h2>4. User Responsibilities</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the Service for illegal purposes</li>
            <li>Attempt unauthorized access to systems</li>
            <li>Reverse engineer the AI model</li>
            <li>Submit false or misleading information</li>
            <li>Resell or redistribute the Service</li>
          </ul>
        </div>

        <div className="content-section">
          <h2>5. Subscription and Payment</h2>
          <ul>
            <li><strong>Tiers:</strong> Free, Paid ($2.99/month), Premium ($6.99/month)</li>
            <li><strong>Billing:</strong> Monthly or annual via Stripe</li>
            <li><strong>Cancellation:</strong> Cancel anytime; access continues until end of billing period</li>
          </ul>
        </div>

        <div className="content-section">
          <h2>6. Intellectual Property</h2>
          <p>All proprietary technology, including the AI model, datasets, and Service structure, are the sole property of Mellodai.</p>
        </div>

        <div className="content-section">
          <h2>7. Limitation of Liability</h2>
          <div style={{background: 'rgba(239, 68, 68, 0.1)', padding: '1.5rem', borderRadius: '10px', margin: '1.5rem 0'}}>
            <p style={{fontWeight: 'bold', marginBottom: '1rem'}}> TO THE MAXIMUM EXTENT PERMITTED BY LAW:</p>
            <p style={{margin: 0}}>Mellodai is not liable for indirect, incidental, or consequential damages, or loss of profits/data resulting from your use of the Service or decisions made based on predictions.</p>
          </div>
          <p>Our total liability shall not exceed the amount you paid in the 12 months preceding the claim.</p>
        </div>

        <div className="content-section">
          <h2>8. Termination</h2>
          <p>We may terminate your account immediately for breaching these Terms. Upon termination:</p>
          <ul>
            <li>Your right to use the Service ceases immediately</li>
            <li>Data retained for 30 days for export</li>
            <li>Personal data deleted after 30 days (anonymized data remains in training set)</li>
          </ul>
        </div>

        <div className="content-section">
          <h2>9. Contact</h2>
          <p>Questions about these Terms? Contact: legal@mellodai.com</p>
          <p style={{textAlign: 'center', fontStyle: 'italic', color: 'var(--textLight)', marginTop: '2rem'}}>Last Updated: November 1, 2025</p>
        </div>
      </div>

      <footer className="static-footer">
        <p>&copy; 2025 Mellodai. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default TermsPage;
